import React from 'react'
import {Button, Modal} from 'react-bootstrap'
import {apiDeleteValidationRole} from '../../../../redux/api'
import {toast} from 'react-toastify'

type Props = {
  showRemoveValidationModal: boolean
  onClose: () => void
  configurationId: any
  resetConfiguration: any
}

function RemoveValidationModal({
  showRemoveValidationModal,
  onClose,
  configurationId,
  resetConfiguration,
}: Props) {
  const handleRemove = () => {
    const toastId = toast.loading('Removing validation role...')

    apiDeleteValidationRole(configurationId)
      .then(({data}: any) => {
        if (data.Status === 200) {
          toast.update(toastId, {
            render: 'The Validation Role was removed',
            type: 'success',
            isLoading: false,
          })

          onClose()
          resetConfiguration()
        } else {
          toast.update(toastId, {
            render: data.Message,
            type: 'error',
            isLoading: false,
          })
        }

        setTimeout(() => toast.dismiss(toastId), 5000)
      })
      .catch(() => {
        toast.update(toastId, {
          render: 'Error while removing validation role',
          type: 'error',
          isLoading: false,
        })

        setTimeout(() => toast.dismiss(toastId), 5000)
      })
  }
  return (
    <Modal
      show={showRemoveValidationModal}
      onHide={onClose}
      centered
      size='lg'
      dialogClassName='custom-modal-width'
    >
      <Modal.Body>
        <h1 className='text-primary mb-5'>Remove Validation Playlist Role</h1>
        <p>You are about to remove the validation playlist role.</p>
        <p>This will not remove the playlist itself, just the validation feature.</p>

        <div className='d-flex align-items-center gap-2 mb-3'>
          <span style={{fontSize: '24px', lineHeight: '1'}}>💡</span>

          <p className='mb-0 d-flex'>
            <strong>Tip:</strong>
            <span className='ms-2'>
              If you still want to use the validation feature, but want to use another playlist,
              <br />
              then use the “Set Validation” option instead.
            </span>
          </p>
        </div>

        <p className='fw-bold'>
          Important: If you remove the validation playlist role, the Validation feature wont work
          <br />
          until you have selected a new validation playlist.
        </p>

        <p className='fw-bold'>Are you sure you want to remove the validation playlist role?</p>

        <div className='d-flex gap-5 mt-7'>
          <Button size='sm' variant='primary' onClick={handleRemove}>
            Yes, remove
          </Button>
          <Button size='sm' variant='secondary' onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default RemoveValidationModal
